var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
import HttpStatus from "http-status-codes";
import { Platform } from "react-native";
import { logError } from "../../../logger/logger";
import * as authActions from "../../../reduxV2/auth/auth.actions";
import * as authApi from "../../../reduxV2/auth/auth.api";
import * as authUtilsV2 from "../../../reduxV2/auth/auth.utils";
import { getStore } from "../../../utils/redux/redux.utils";
import { cancelPendingCalls } from "../api.utils";
var WAIT_FOR_OTHER_TAB_TIME = 7000;
var WAIT_FOR_OTHER_TAB_INTERVAL_TIME = 500;
var isRefreshingAccessToken = false;
// Cancel any in-flight requests and sign the user out. Used whenever the
// access token can't be recovered, so the app doesn't stay stuck on a spinner.
var forceSignOut = function () {
    var _a;
    cancelPendingCalls();
    (_a = getStore()) === null || _a === void 0 ? void 0 : _a.dispatch(authActions.signOutStart.getAction());
};
var waitingForRefreshingAccessTokenCompletion = [];
var waitForRefreshingAccessTokenCompletion = function () {
    return new Promise(function (resolve, reject) {
        waitingForRefreshingAccessTokenCompletion.push({ resolve: resolve, reject: reject });
    });
};
// Wait 7 seconds for another tab to finish refreshing the access token
var pollAccessTokenRefreshCompletion = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var refreshToken, _a, iteration, timeInSeconds;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                refreshToken = params.refreshToken, _a = params.iteration, iteration = _a === void 0 ? 0 : _a;
                if (!(iteration >= WAIT_FOR_OTHER_TAB_TIME / WAIT_FOR_OTHER_TAB_INTERVAL_TIME)) return [3 /*break*/, 2];
                return [4 /*yield*/, authUtilsV2.setAccessTokenRefreshCompleted()];
            case 1:
                _b.sent();
                timeInSeconds = Math.round(WAIT_FOR_OTHER_TAB_TIME / 1000);
                // eslint-disable-next-line no-console
                console.log("Refreshing access token polling stopped after ".concat(timeInSeconds, " seconds, starting refresh now"));
                return [2 /*return*/, false];
            case 2: return [4 /*yield*/, new Promise(function (resolve) {
                    setTimeout(resolve, WAIT_FOR_OTHER_TAB_INTERVAL_TIME);
                })];
            case 3:
                _b.sent();
                return [4 /*yield*/, authUtilsV2.getAccessTokenRefreshIsInProgress()];
            case 4:
                if (!_b.sent()) return [3 /*break*/, 6];
                return [4 /*yield*/, pollAccessTokenRefreshCompletion({
                        refreshToken: refreshToken,
                        iteration: iteration + 1,
                    })];
            case 5: return [2 /*return*/, _b.sent()];
            case 6: return [2 /*return*/, true];
        }
    });
}); };
var refreshAccessToken = function (refreshToken) { return __awaiter(void 0, void 0, void 0, function () {
    var refreshCompleted, response, unknownError_1, error_1, axiosError;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 12, , 14]);
                if (!isRefreshingAccessToken) return [3 /*break*/, 2];
                (_a = getStore()) === null || _a === void 0 ? void 0 : _a.dispatch(authActions.refreshSuccessStart.getAction({}));
                // eslint-disable-next-line no-console
                console.log("Refreshing access token already in progress. Waiting for completion...");
                return [4 /*yield*/, waitForRefreshingAccessTokenCompletion()];
            case 1:
                _d.sent();
                return [2 /*return*/, true];
            case 2:
                if (!(Platform.OS === "web")) return [3 /*break*/, 6];
                return [4 /*yield*/, authUtilsV2.getAccessTokenRefreshIsInProgress()];
            case 3:
                if (!_d.sent()) return [3 /*break*/, 6];
                // eslint-disable-next-line no-console
                console.log("Refreshing access token already in progress on other tab. Polling for completion...");
                return [4 /*yield*/, pollAccessTokenRefreshCompletion({
                        refreshToken: refreshToken,
                    })];
            case 4:
                refreshCompleted = _d.sent();
                if (refreshCompleted) {
                    return [2 /*return*/, true];
                }
                if (!isRefreshingAccessToken) return [3 /*break*/, 6];
                // eslint-disable-next-line no-console
                console.log("Refreshing access token already in progress. Waiting for completion...");
                return [4 /*yield*/, waitForRefreshingAccessTokenCompletion()];
            case 5:
                _d.sent();
                return [2 /*return*/, true];
            case 6:
                // eslint-disable-next-line no-console
                console.log("Refreshing access token started");
                isRefreshingAccessToken = true;
                return [4 /*yield*/, authUtilsV2.setAccessTokenRefreshInProgress()];
            case 7:
                _d.sent();
                return [4 /*yield*/, authApi.refreshAccessToken(refreshToken)];
            case 8:
                response = _d.sent();
                cancelPendingCalls();
                // Store new tokens
                return [4 /*yield*/, authUtilsV2.setAccessToken(response.accessToken)];
            case 9:
                // Store new tokens
                _d.sent();
                return [4 /*yield*/, authUtilsV2.setRefreshToken(response.refreshToken)];
            case 10:
                _d.sent();
                isRefreshingAccessToken = false;
                return [4 /*yield*/, authUtilsV2.setAccessTokenRefreshCompleted()];
            case 11:
                _d.sent();
                // Resolve & clear queue of pending calls
                waitingForRefreshingAccessTokenCompletion.forEach(function (completion) {
                    completion.resolve();
                });
                waitingForRefreshingAccessTokenCompletion = [];
                (_b = getStore()) === null || _b === void 0 ? void 0 : _b.dispatch(authActions.refreshSuccessSucceeded.getAction({}));
                return [2 /*return*/, true];
            case 12:
                unknownError_1 = _d.sent();
                error_1 = unknownError_1;
                logError({
                    error: new Error("Refreshing access token failed"),
                    parameters: {
                        error: error_1,
                    },
                });
                isRefreshingAccessToken = false;
                return [4 /*yield*/, authUtilsV2.setAccessTokenRefreshCompleted()];
            case 13:
                _d.sent();
                // Reject & clear queue of pending calls
                waitingForRefreshingAccessTokenCompletion.forEach(function (completion) {
                    completion.reject(error_1);
                });
                waitingForRefreshingAccessTokenCompletion = [];
                axiosError = error_1;
                if (axiosError.isAxiosError &&
                    ((_c = axiosError.response) === null || _c === void 0 ? void 0 : _c.status) !== HttpStatus.OK) {
                    forceSignOut();
                }
                return [2 /*return*/, false];
            case 14: return [2 /*return*/];
        }
    });
}); };
// Interceptors
var success = function (response) { return response; };
var error = function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var refreshToken, success_1, newAccessToken, newConfig;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                if (!(((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === HttpStatus.UNAUTHORIZED)) return [3 /*break*/, 4];
                // eslint-disable-next-line no-console
                console.log("".concat(HttpStatus.UNAUTHORIZED, " for request with base URL: ").concat(error.config.baseURL, ")"), error);
                return [4 /*yield*/, authUtilsV2.getRefreshToken()];
            case 1:
                refreshToken = _d.sent();
                if (!refreshToken) {
                    forceSignOut();
                    return [2 /*return*/, Promise.reject(error)];
                }
                return [4 /*yield*/, refreshAccessToken(refreshToken)];
            case 2:
                success_1 = _d.sent();
                if (!success_1) {
                    // Refreshing failed and the token can't be recovered: sign out
                    // immediately instead of leaving the app stuck on a spinner.
                    forceSignOut();
                    return [2 /*return*/, Promise.reject(error)];
                }
                return [4 /*yield*/, authUtilsV2.getAccessToken()];
            case 3:
                newAccessToken = _d.sent();
                if (!newAccessToken) {
                    forceSignOut();
                    return [2 /*return*/, Promise.reject(error)];
                }
                newConfig = error.config;
                if (
                // TODO:
                ((_b = newConfig.baseURL) === null || _b === void 0 ? void 0 : _b.includes("serverless")) ||
                    (
                    // TODO:
                    // This is not the best way to check for the next api, but if the next api is connected via localhost the url does not contain 'next'
                    (_c = newConfig.baseURL) === null || _c === void 0 ? void 0 : _c.includes("v2"))) {
                    newConfig.headers.Authorization = "Bearer ".concat(newAccessToken);
                }
                else {
                    newConfig.headers.Authorization = newAccessToken;
                }
                return [2 /*return*/, Promise.resolve(axios(newConfig))];
            case 4: return [2 /*return*/, Promise.reject(error)];
        }
    });
}); };
// eslint-disable-next-line import/no-default-export
export default {
    success: success,
    error: error,
};
